/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardWarningDto
 */
export interface WizardWarningDto {
    /**
     * 
     * @type {string}
     * @memberof WizardWarningDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WizardWarningDto
     */
    message: string;
}

/**
 * Check if a given object implements the WizardWarningDto interface.
 */
export function instanceOfWizardWarningDto(value: object): value is WizardWarningDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function WizardWarningDtoFromJSON(json: any): WizardWarningDto {
    return WizardWarningDtoFromJSONTyped(json, false);
}

export function WizardWarningDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardWarningDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'message': json['message'],
    };
}

export function WizardWarningDtoToJSON(json: any): WizardWarningDto {
    return WizardWarningDtoToJSONTyped(json, false);
}

export function WizardWarningDtoToJSONTyped(value?: WizardWarningDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
    };
}

